import { useEffect, useState } from 'react';
import { Users, Calendar, Wallet, BookOpen, TrendingUp, ArrowUpRight, ArrowDownLeft, RefreshCw } from 'lucide-react';
import api from '../../lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/dashboard').then(r => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><div className="spin-gold w-8 h-8" /></div>;
  if (!stats) return <div className="text-center py-20 text-[#A1A1AA]">Erreur chargement</div>;

  const cards = [
    { label: 'Utilisateurs', value: stats.total_users, icon: Users, color: 'text-blue-400', bg: 'bg-blue-500/10' },
    { label: 'Evenements actifs', value: stats.active_events, icon: Calendar, color: 'text-[#D4AF37]', bg: 'bg-[#D4AF37]/10' },
    { label: 'Revenus cashless', value: `${stats.total_revenue.toFixed(2)} EUR`, icon: TrendingUp, color: 'text-[#10B981]', bg: 'bg-[#10B981]/10' },
    { label: 'Reservations', value: stats.total_reservations, icon: BookOpen, color: 'text-purple-400', bg: 'bg-purple-500/10' },
    { label: 'Portefeuilles', value: stats.total_wallets, icon: Wallet, color: 'text-orange-400', bg: 'bg-orange-500/10' },
    { label: 'En attente', value: stats.pending_reservations, icon: BookOpen, color: 'text-yellow-400', bg: 'bg-yellow-500/10' },
  ];

  const txIcon = (type) => {
    if (type === 'topup') return <ArrowDownLeft className="w-3.5 h-3.5 text-[#10B981]" />;
    if (type === 'refund') return <RefreshCw className="w-3.5 h-3.5 text-[#F59E0B]" />;
    return <ArrowUpRight className="w-3.5 h-3.5 text-[#EF4444]" />;
  };

  return (
    <div className="fade-in" data-testid="admin-dashboard">
      <h1 className="text-2xl font-semibold tracking-tight mb-6" style={{ fontFamily: 'Outfit' }}>Dashboard</h1>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {cards.map(c => (
          <div key={c.label} className="bg-[#121212] border border-white/5 rounded-xl p-4" data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, '-')}`}>
            <div className="flex items-center gap-3 mb-3">
              <div className={`${c.bg} p-2 rounded-lg`}><c.icon className={`w-4 h-4 ${c.color}`} /></div>
              <span className="text-xs text-[#A1A1AA]">{c.label}</span>
            </div>
            <div className="text-xl font-bold" style={{ fontFamily: 'JetBrains Mono' }}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* Recent Transactions */}
      <div className="bg-[#121212] border border-white/5 rounded-xl p-5">
        <h2 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Outfit' }}>Transactions recentes</h2>
        {stats.recent_transactions.length === 0 ? (
          <p className="text-sm text-[#A1A1AA] text-center py-6">Aucune transaction</p>
        ) : (
          <div className="space-y-2">
            {stats.recent_transactions.map(tx => (
              <div key={tx.tx_id} className="flex items-center gap-3 py-2.5 border-b border-white/5 last:border-0">
                <div className="bg-white/5 p-1.5 rounded-md">{txIcon(tx.type)}</div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm truncate">{tx.description || tx.type}</div>
                  <div className="text-[10px] text-[#A1A1AA]">
                    {new Date(tx.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
                <div className={`text-sm font-semibold ${tx.amount > 0 ? 'text-[#10B981]' : 'text-[#EF4444]'}`}
                  style={{ fontFamily: 'JetBrains Mono' }}>
                  {tx.amount > 0 ? '+' : ''}{tx.amount.toFixed(2)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
